@import (reference) '../../../../../constants/spacing.module.less';

.supplier-preview-container {
  width: 100%;
  border-radius: 4px;
  border: 1px solid var(--gray-DFE4E8);
  background: var(--white);
  margin-bottom: @space-16;
}

.supplier-preview {
  width: 100%;
  height: 100%;
}
